import moment from "moment";
import { getDecimalSeparator } from "./languages";

export function formatAsDate(d: Date): any {
  return moment(d).format("YYYY-MM-DD");
}

export function countDifferenceOfDays(dEnd: Date): any {
  return moment(dEnd)
    .endOf("day")
    .fromNow();
}

export function parseLocaleNumberQty(stringNumber: string, locale: string) {
  return parseFloat(
    stringNumber.replace(new RegExp("\\" + getDecimalSeparator(locale)), ".")
  );
}

export function formatAsMoney(
  amomunt: number,
  currencyType: string,
  locale: string
) {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyType,
    currencyDisplay: "code",
    useGrouping: false,
  })
    .format(amomunt)
    .replace(currencyType, "");
}
